import { Timestamp } from "firebase/firestore";

import type {
  FirestoreProductDocument,
  Product,
} from "@dashboard/types/product";

import { readEntitySource, writeEntitySource } from "./entitySource";

export const readProduct = (doc: FirestoreProductDocument): Product => {
  const {
    restaurantRef,
    createdAt,
    modifiedAt,
    source,
    supplierInfo,
    productType,
    ingredientIds,
    productIds,
    optionalAllergenIds,
    mayContainAllergenIds,
    additionalAllergenIds,
    ...productRest
  } = doc;

  const product: Product = {
    ...productRest,
    // Id lists are absent or explicitly null on older documents.
    ingredientIds: ingredientIds || [],
    productIds: productIds || [],
    optionalAllergenIds: optionalAllergenIds || [],
    mayContainAllergenIds: mayContainAllergenIds || [],
    additionalAllergenIds: additionalAllergenIds || [],
    // supplierInfo would be undefined since we haven't backfilled this field yet.
    // However firestore doesn't accept undefined, when writes happen.
    // So we convert it to null here.
    supplierInfo: supplierInfo ?? null,
    // productType is not backfilled either, so coerce undefined to null.
    productType: productType ?? null,
    source: readEntitySource(source),
    createdAtMillis: createdAt.toMillis(),
    modifiedAtMillis: (modifiedAt || createdAt).toMillis(),
  };

  return product;
};

// Converts a product object to a firestore product document
export const writeProduct = (
  product: Product,
  isNew: boolean
): FirestoreProductDocument => {
  const updateTs = Timestamp.now();
  const additionalFieldsNewProduct = isNew ? { createdAt: updateTs } : {};

  // we don't write source to the product object in firestore.
  const { createdAtMillis, modifiedAtMillis, source, ...productRest } = product;
  const firestoreProduct = {
    ...productRest,
    ...additionalFieldsNewProduct,
    modifiedAt: updateTs,
    source: writeEntitySource(source),
  } as FirestoreProductDocument;

  return firestoreProduct;
};
